import { Appearance } from '@stripe/stripe-js';

import { CalmTheme } from '@calm-web/design-system';

export const stripeAppearanceOptions: Appearance = {
	labels: 'floating',
	variables: {
		fontFamily: 'Figtree, Arial',
		colorPrimary: CalmTheme.palette.buttonBlue,
		colorText: CalmTheme.palette.gray7,
		colorDanger: CalmTheme.palette.errorRed,
		borderRadius: '36px',
	},
	rules: {
		'.Tab': {
			borderRadius: '6px',
		},
		'.Label': {
			color: CalmTheme.palette.gray5,
			fontWeight: '500',
		},
		'.Input': {
			border: `2px ${CalmTheme.palette.gray2} solid`,
			borderRadius: '6px',
			color: CalmTheme.palette.gray5,
			fontWeight: '500',
		},
		'.Error': {
			fontSize: '0.75rem',
			fontWeight: '500',
			padding: '4px 1px 0 0',
		},
	},
};

export const desktopStripeAppearanceOptions: Appearance = {
	...stripeAppearanceOptions,
	rules: {
		...stripeAppearanceOptions.rules,
		'.Error': {
			fontSize: `${0.75 * 1.125}rem`,
			fontWeight: '500',
			padding: '4px 1px 0 0',
		},
	},
};

export const sleepAiStripeAppearanceOptions: Appearance = {
	labels: 'floating',
	variables: {
		fontFamily: 'Figtree, Arial',
		colorPrimary: 'white',
		colorText: 'white',
		colorTextPlaceholder: CalmTheme.palette.whiteAlpha40,
		colorDanger: CalmTheme.palette.sleepAiErrorRed,
		borderRadius: '8px',
	},
	rules: {
		'.Tab': {
			borderRadius: '8px',
			backgroundColor: CalmTheme.palette.sleepAiUnselectedPurple,
			border: '1px transparent solid',
		},
		'.Label': {
			color: CalmTheme.palette.whiteAlpha80,
			fontWeight: '500',
		},
		'.Input': {
			border: '1px transparent solid',
			borderRadius: '8px',
			backgroundColor: CalmTheme.palette.sleepAiUnselectedPurple,
			color: 'white',
			fontWeight: '500',
		},
		'.Input:focus': {
			backgroundColor: CalmTheme.palette.sleepAiSelectedPurple,
			borderColor: 'white',
		},
		'.Input--filled': {
			backgroundColor: CalmTheme.palette.sleepAiSelectedPurple,
			borderColor: 'white',
		},
		'.Error': {
			fontSize: '0.75rem',
			fontWeight: '500',
			padding: '4px 1px 0 0',
			color: CalmTheme.palette.sleepAiErrorRed,
		},
	},
};

export const desktopSleepAiStripeAppearanceOptions: Appearance = {
	...sleepAiStripeAppearanceOptions,
	rules: {
		...sleepAiStripeAppearanceOptions.rules,
		'.Error': {
			fontSize: `${0.75 * 1.125}rem`,
			fontWeight: '500',
			padding: '4px 1px 0 0',
			color: CalmTheme.palette.sleepAiErrorRed,
		},
	},
};
